// Models
import { UnitOfMeasureModel } from '../models';

export namespace UnitOfMeasureActions {
	export class GetAll {
		static readonly type = '[UnitOfMeasure] Get Units of Measure';
		constructor(public data: { showSpinner?: boolean; showToast?: boolean } = { showSpinner: false, showToast: false }) {}
	}

	export class SetAll {
		static readonly type = '[UnitOfMeasure] Set Units of Measure';
		constructor(public unitsOfMeasure: UnitOfMeasureModel[]) {}
	}

	export class Create {
		static readonly type = '[Company] Create Unit of Measure';
		constructor(public data: { unitOfMeasure: UnitOfMeasureModel; showSpinner?: boolean; showToast?: boolean } = { unitOfMeasure: null, showSpinner: false, showToast: false }) {}
	}

	export class CreateSuccess {
		static readonly type = '[UnitOfMeasure] Create Unit of Measure Success';
		constructor(public unitOfMeasure: UnitOfMeasureModel) {}
	}

	export class CreateError {
		static readonly type = '[UnitOfMeasure] Create Unit of Measure Error';
	}

	export class Update {
		static readonly type = '[UnitOfMeasure] Update Unit of Measure';
		constructor(public data: { unitOfMeasure: UnitOfMeasureModel; showSpinner?: boolean; showToast?: boolean } = { unitOfMeasure: null, showSpinner: false, showToast: false }) {}
	}

	export class UpdateSuccess {
		static readonly type = '[UnitOfMeasure] Update Unit of Measure Success';
		constructor(public unitOfMeasure: UnitOfMeasureModel) {}
	}

	export class UpdateError {
		static readonly type = '[UnitOfMeasure] Update Unit of Measure Error';
	}
}
